import { hashString } from '@/features/shared/tools'
import type { Fetch } from '../types'

export function configCacheFactory() {
  type CacheData = {
    data: Response,
    cacheExpiration?: Date,
  }

  const cache: Record<string, CacheData> = {}

  return function configCache(nextFetch: Fetch): Fetch {
    return async function (input: RequestInfo | URL, init?: RequestInit) {
      if (init?.appCache !== true) {
        return await nextFetch(input, init)
      }
      const method = (input instanceof Request ? input.method : undefined) ?? init?.method ?? 'GET'
      if (["GET", "POST"].includes(method) === false) {
        throw new Error("Non supporté")
      }

      if ((init?.appCacheDurationEnSecondes ?? 1) < 1) {
        throw new Error("La durée de vie du cache doit être supérieure à 0")
      }

      const url = ((input as Request)?.url ?? input).toLowerCase()

      const cacheKey = [method, url]
      if ((input as Request)?.body || init?.body) {
        const body = (input as Request)?.body ?? init?.body
        cacheKey.push(`${body}`)
      }
      if (Array.isArray(init.appCacheAddKey)) {
        init.appCacheAddKey.forEach(key => cacheKey.push(`${key}`))
      } else if (init.appCacheAddKey !== undefined) {
        cacheKey.push(`${init.appCacheAddKey}`)
      }
      const hash = await hashString(cacheKey.join("_"))

      const cacheResult = cache[hash]
      const estCacheExpiré =
        cacheResult?.cacheExpiration !== undefined
        && ((+cacheResult.cacheExpiration - +new Date()) < 0)

      if (cacheResult && !estCacheExpiré) {
        return cacheResult?.data.clone()
      }
      const result = await nextFetch(input, init)
      if (result.ok) {
        if (init.appCacheDurationEnSecondes) {
          const cacheExpiration = new Date(+new Date() + init.appCacheDurationEnSecondes * 1000)
          cache[hash] = {
            data: result.clone(),
            cacheExpiration: cacheExpiration,
          }
        } else {
          cache[hash] = { data: result.clone() }
        }
      }
      return result
    }
  }
}




